import styled from 'styled-components';
import { size } from 'polished';
import { AbstractButton } from '../../atoms/AbstractButton/AbstractButton';
import { FontSize } from '../../../styles/variables';

export const StyledModal = styled.div`
  min-width: 16.875rem;
  position: absolute;
  display: flex;
  align-items: center;
  font-size: ${FontSize.Normal};
  padding: 0.625rem;
  background: ${(props) => props.theme.color.white};
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledCloseButton = styled(AbstractButton)`
  ${size('2.1875rem')};
  display: flex;
  align-items: flex-start;
  align-self: flex-start;
  justify-content: center;
  color: ${({ theme }) => theme.color.blue};
  cursor: pointer;

  svg {
    ${size('0.875rem')};
  }

  &:focus {
    transform: scale(1.08);
    border: 1px solid ${({ theme }) => theme.color.blue};
    box-shadow: 0px 0px 4px ${({ theme }) => theme.color.blue};
  }
`;
